import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { MessagePage } from './pages/MessagePage';
import { HowThisWorksPage } from './pages/HowThisWorksPage';
import { SignUpPage } from './pages/auth/SignUpPage';
import { OtpPage } from './pages/auth/OtpPage';
import { SuccessPage } from './pages/auth/SuccessPage';
import { FlowLayout } from './layouts/FlowLayout';
import { WithNavLayout } from './layouts/WithNavLayout';
import { MorePage } from './pages/MorePage';
import { ContactPage } from './pages/ContactPage';

function ScheduleTourPage() {
  /**
   * TODO: resolve issues with tour scheduling to enable this feature. Contact QA.
   * The RG Schedule a tour feature is completely disabled because of a bug with tour dates.
   * To enable and rebuild this for the new MM flow (as we have done with Contact Property), we must fix the issue with tour dates.
   * Right now, schedule tour defaults to Knock.
   */
  return <Navigate to="/" replace />;
}

export function Router() {
  return (
    <Routes>
      <Route element={<FlowLayout />}>
        <Route index element={<MessagePage />} />
        <Route path="/how-it-works" element={<HowThisWorksPage />} />
        <Route path="/auth" element={<WithNavLayout />}>
          <Route index element={<Navigate to="create" replace />} />
          <Route path="create" element={<SignUpPage />} />
          <Route path="verify" element={<OtpPage />} />
          <Route path="success" element={<SuccessPage />} />
          <Route path="*" element={<Navigate to="create" replace />} />
        </Route>
        <Route path="schedule" element={<ScheduleTourPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="more" element={<MorePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
